import React from "react";
import "./ConfirmationModal.css";

const ConfirmationModal = ({ status, onClose, onContinue }) => {
    if (!status) return null;

    const isSuccess = status === "success";

    return (
        <div className="confirmation-overlay" role="dialog" aria-modal="true">
            <div className={`confirmation-box ${isSuccess ? "success" : "error"}`}>
                <div className="confirmation-icon">{isSuccess ? "✓" : "✕"}</div>
                <h3 className="confirmation-title">
                    {isSuccess ? "Message Sent!" : "Something Went Wrong"}
                </h3>
                <p className="confirmation-text">
                    {isSuccess
                        ? "Thank you for reaching out. We'll get back to you as soon as possible."
                        : "Your message could not be sent. Please try again or contact us directly."}
                </p>
                <div className="confirmation-actions">
                    {isSuccess ? (
                        <button className="confirmation-btn primary" onClick={onContinue}>
                            Continue
                        </button>
                    ) : (
                        <button className="confirmation-btn primary" onClick={onClose}>
                            Try Again
                        </button>
                    )}
                    {isSuccess && (
                        <button className="confirmation-btn secondary" onClick={onClose}>
                            Close
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
